import styled from '@emotion/styled';

import { SPACING } from '../../../../../styles/emotion';

export const ChipContentsWrapper = styled.div`
  align-items: center;
  column-gap: ${SPACING.XS};
  display: flex;
  line-height: 150%;
  text-align: left;
`;
